<template>
  <div class="navigation d-flex flex-column align-items-center pt-5 page-wrap">
    <div class="h2 d-block py-2 fw-bold" v-for="route in routes" :key="route.name">
      <router-link v-if="route.target !== '_blank'" class="text-black text-decoration-none" :to="route.url">{{ route.name }}</router-link>
      <a v-else class="text-black text-decoration-none" :href="route.page" :target="route.target" rel="noopener noreferrer">{{ route.name }}</a>
    </div>

    <div class="text-center mt-5 buildnumber d-none">
      Version<br/>
      {{ hash }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'NavigationView',
  components: {},
  data() {
    const navigation = this.$store.getters.navigation;
    let routes = [];

    // eslint-disable-next-line no-unused-vars
    for (const [name, item] of Object.entries(navigation)) {
      if(item.inMenu) {
        routes.push(item);
      }
    }

    return {
      routes,
      hash: ''
    }
  },

  mounted() {
    //get the head with the index.[hash].js javascript file and store the hash in to a variable
    const head = document.querySelector('head');
    const script = head.querySelector('script[src*="index."]');
    this.hash = script.src.split('/').pop().split('.')[1];

    //only show the build number when the header.header is clicked 5 times
    window.buildnumberCounter = 0;
    const header = document.querySelector('header.header');
    header.addEventListener('click', () => {
      window.buildnumberCounter++;
      if(window.buildnumberCounter === 5) {
        const buildnumber = document.querySelector('.buildnumber');
        buildnumber.classList.remove('d-none');
      }
    });
  }
}
</script>
